// The goal of this module is to be able to mock the localStorage in tests

export const getItem = key => window.localStorage.getItem(key);

export const setItem = (key, value) => window.localStorage.setItem(key, value);

export const removeItem = key => window.localStorage.removeItem(key);
